import * as React from "react";
import { useHangars } from "../hooks/useHangars";
import { Hangar } from "../types";
import { HangarsSkeleton } from "../screens/Hangars/HangarsSkeleton";

const HangarsStateContainerState = React.createContext<{
  ready: boolean;
  hangars: Hangar[];
  setHangars: (hangars: Hangar[]) => void;
}>({});

export const HangarsStateContainer: React.FC<{
  children?: React.ReactNode;
  isReference: boolean;
}> = ({ children, isReference }) => {
  const { ready, hangars, setHangars } = useHangars(isReference);
  return (
    <HangarsStateContainerState.Provider
      value={{
        ready,
        hangars,
        setHangars,
      }}
    >
      {ready ? children : <HangarsSkeleton />}
    </HangarsStateContainerState.Provider>
  );
};

/**
 * Hook into the current identity context.
 */
export const useHangarsState = () =>
  React.useContext(HangarsStateContainerState);
